import CityPageTemplate from "../city-template/CityPageTemplate";
import { boulderConfig } from "./data";

export default function BoulderPage() {
  return <CityPageTemplate config={boulderConfig} />;
}